import { IAppState } from '../../common/state';

export function selectMlSearchSessionGuid(state: IAppState) {
  return state.mlSearchSessionGuid;
}
